import setActiveFuelCard from './setActiveFuelCard';
import getFuelCards from './getFuelCards';

const operations = {
  getFuelCards,
  setActiveFuelCard,
};

export default operations;
